import request from '@/utils/request'

// 查询协议信息列表
export function listAgreement(query) {
  return request({
    url: '/agreement/agreement/list',
    method: 'get',
    params: query
  })
}

// 查询协议信息分页
export function pageAgreement(query) {
  return request({
    url: '/agreement/agreement/page',
    method: 'get',
    params: query
  })
}

// 查询协议信息详细
export function getAgreement(data) {
  return request({
    url: '/agreement/agreement/detail',
    method: 'get',
    params: data
  })
}

// 新增协议信息
export function addAgreement(data) {
  return request({
    url: '/agreement/agreement/add',
    method: 'post',
    data: data
  })
}

// 修改协议信息
export function updateAgreement(data) {
  return request({
    url: '/agreement/agreement/edit',
    method: 'post',
    data: data
  })
}

// 删除协议信息
export function delAgreement(data) {
  return request({
    url: '/agreement/agreement/delete',
    method: 'post',
    data: data
  })
}
